import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import React, {ReactNode} from "react";
import ReactMarkdown, {Components} from "react-markdown";
import remarkGfm from "remark-gfm";

const paragraphSx = {
    userSelect: "text",
    wordBreak: "break-word",
    marginBottom: "16px",
    "&:last-child": {
        marginBottom: 0,
    },
} as const;

function Paragraph({children}: {children?: ReactNode}) {
    return (
        <Typography component="div" variant="body2" sx={paragraphSx}>
            {children}
        </Typography>
    );
}

function Heading({children}: {children?: ReactNode}) {
    return (
        <Typography component="div" variant="body1" sx={paragraphSx}>
            {children}
        </Typography>
    );
}

const components: Components = {
    p: Paragraph,
    h1: ({children}) => (
        <Typography component="div" variant="h6" sx={paragraphSx}>
            {children}
        </Typography>
    ),
    h2: Heading,
    h3: Heading,
    h4: Heading,
    h5: Heading,
    h6: Heading,
    li: ({children}) => (
        <Typography component="li" variant="body2">
            {children}
        </Typography>
    ),
    a: ({href, children}) => <Link href={href}>{children}</Link>,
};

/**
 * Minimal mirror of the main app's Markdown + sitemap muiMappings: paragraphs
 * as body2 with 16px spacing, headings mapped down, links via MUI Link.
 */
function MarkdownDescription({markdownText}: {markdownText: string}) {
    return <ReactMarkdown remarkPlugins={[remarkGfm]} components={components} children={markdownText} />;
}

export default React.memo(MarkdownDescription);
